/**
 * AttachmentModalHeader Component
 * Displays modal header with title and close button
 */
import { useState } from 'react'
import '../styles/AttachmentModalHeader.css'

export default function AttachmentModalHeader({ title = 'Attachment Viewer', onClose }) {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div className="attachment-modal-header">
      <h3 className="attachment-modal-title">
        {title}
      </h3>
      <button
        onClick={onClose}
        className="attachment-modal-close-btn"
        style={{
          backgroundColor: isHovered ? '#f1f5f9' : 'transparent',
          color: isHovered ? '#475569' : '#94a3b8'
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        ×
      </button>
    </div>
  )
}
